import { z } from "zod";
import { passwordValidation } from "../../constants/regex";
import { zEmailSchema, zString } from "./commonSchemaObjects";

export const passcodeSchema = z.object({
  email: zEmailSchema,
});

export const resetPasswordSchema = z
  .object({
    passcode:  zString.zRequired
      .max(8, "Passcode should have minimum 8 characters"),
    new_password:  zString.zRequired
      .min(8, "Password should have minimum 8 characters")
      .max(16, "Password can have maximum 16 characters")
      .regex(passwordValidation, "Password is not in expected format"),
    confirm_password:  zString.zRequired,
  })
  .refine((data) => data.new_password === data.confirm_password, {
    message: "Passwords don't match",
    path: ["confirm_password"],
  });
